module.exports = __webpack_public_path__ + "static/media/close.c831424e.svg";